
import axios from "axios";
import { API_URL } from "../appConstants";
import { axiosInstance } from "./axiosInstance";

export async function fetchClinicianUser(USER_ID, ID = null) {
    try {
        //ID is CliniciansInFacilityJobsAndShifts ID sometime if facility call it.
        const response = await axiosInstance.get(`${API_URL}user`, {
            
            params: { USER_ID, ID } // Pass USER_ID as a query parameter
        });
        console.log("Clinician Profile", response.data.OUTPUT)
        if (response?.data?.STATUS) {
            return response.data.OUTPUT;
        } else {
            return []; // Return an empty array or handle as needed
        }
    } catch (error) {
        console.error('Error fetching clinician user:', error.message);
        return []; // Return an empty array or handle the error accordingly
    }
}


export async function fetchClinicianCertificateDocuments(ROLE_ID, ID = null) {
    try {
        //ID may be CliniciansInFacilityJobsAndShifts ID sometime if facility call it.
        const response = await axiosInstance.get(`${API_URL}fetchClinicianCertificationDocuments`, {
            params: {
                ID: ROLE_ID,
                USER_ID: ID
            } // Pass USER_ID as a query parameter
        });

        if (response) {
            return response.data;
        } else {
            return []; // Return an empty array or handle as needed
        }
    } catch (error) {
        console.error('Error fetching clinican certificate documents:', error.message);
        return []; // Return an empty array or handle the error accordingly
    }
}

export async function getAllCliniciansDocumentsPath(ROLE_ID, ID = null) {
    try {
        //ID may be CliniciansInFacilityJobsAndShifts ID sometime if facility call it.
        const response = await axiosInstance.get(`${API_URL}job/getAllCliniciansDocumentsPath`, {
            params: {
                ID: ROLE_ID,
                USER_ID: ID
            } // Pass USER_ID as a query parameter
        });

        if (response) {
            return response.data;
        } else {
            return []; // Return an empty array or handle as needed
        }
    } catch (error) {
        console.error('Error fetching clinican certificate documents:', error.message);
        return []; // Return an empty array or handle the error accordingly
    }
}

// Pass USER_ID properly
export async function fetchClinicianMiscellaneousDocuments(USER_ID = null) {
    try {
        const response = await axiosInstance.get(
            `${API_URL}job/getCliniciansMiscellaneousDocuments`,
            {
                params: { USER_ID }
            }
        );

        return response?.data ?? [];
    } catch (error) {
        console.error("Error fetching clinician miscellaneous documents:", error.message);
        return [];
    }
}


export async function fetchCertificateDocumentsCount(clinicianID = null) {
    try {
        //ID may be CliniciansInFacilityJobsAndShifts ID sometime if facility call it.
        const response = await axiosInstance.get(`${API_URL}fetchAddedClinicianCertificationDocuments`, {
            params: {
                clinicianID: clinicianID,
            } // Pass USER_ID as a query parameter
        });
        // console.log("fetchClinicianUser: ", response.data);

        if (response) {
            // console.log("fetchClinicianCertificateDocuments: ", response.data);
            return response.data;
        } else {
            return []; // Return an empty array or handle as needed
        }
    } catch (error) {
        console.error('Error fetching clinican certificate documents:', error.message);
        return []; // Return an empty array or handle the error accordingly
    }
}


export async function fetchClinicanDataFromSpecialityId(specialityID = null) {
    try {
        //ID may be CliniciansInFacilityJobsAndShifts ID sometime if facility call it.
        const response = await axiosInstance.get(`${API_URL}job/hired-clinicians-details/${specialityID}`, {
        });

        if (response) {
            // console.log("fetchClinicianCertificateDocuments: ", response.data);
            return response.data;
        } else {
            return []; // Return an empty array or handle as needed
        }
    } catch (error) {
        console.error('Error fetching clinican certificate documents:', error.message);
        return []; // Return an empty array or handle the error accordingly
    }
}

